import { IconProps } from '@euler/app/components/icons/types';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { FC, memo } from 'react';
import Svg, { Path } from 'react-native-svg';

export const ProgressIcon: FC<IconProps> = memo(
  ({ width, height, size, color }) => {
    const { rpx } = useResponsiveContext();
    size = size ?? rpx(40);
    return (
      <Svg
        width={width ?? size}
        height={height ?? size}
        viewBox="0 0 40 40"
        fill="none"
      >
        <Path
          d="M31 4H8.14286C7.51071 4 7 4.51071 7 5.14286V34.8571C7 35.4893 7.51071 36 8.14286 36H31C31.6321 36 32.1429 35.4893 32.1429 34.8571V5.14286C32.1429 4.51071 31.6321 4 31 4ZM29.5714 33.4286H9.57143V26.25H13.0679C13.4821 27.4214 14.2107 28.475 15.1786 29.275C16.4107 30.2929 17.9714 30.8571 19.5714 30.8571C21.1714 30.8571 22.7321 30.2964 23.9643 29.275C24.9321 28.475 25.6607 27.4214 26.075 26.25H29.5714V24H24.2714L24.0857 24.8821C23.6571 27.0179 21.7571 28.5714 19.5714 28.5714C17.3857 28.5714 15.4857 27.0179 15.0536 24.8821L14.8679 24H9.57143V6.57143H29.5714V33.4286ZM12.7143 13.8929H26.4286C26.5857 13.8929 26.7143 13.7643 26.7143 13.6071V11.8929C26.7143 11.7357 26.5857 11.6071 26.4286 11.6071H12.7143C12.5571 11.6071 12.4286 11.7357 12.4286 11.8929V13.6071C12.4286 13.7643 12.5571 13.8929 12.7143 13.8929ZM12.7143 19.6071H26.4286C26.5857 19.6071 26.7143 19.4786 26.7143 19.3214V17.6071C26.7143 17.45 26.5857 17.3214 26.4286 17.3214H12.7143C12.5571 17.3214 12.4286 17.45 12.4286 17.6071V19.3214C12.4286 19.4786 12.5571 19.6071 12.7143 19.6071Z"
          fill={color}
        />
      </Svg>
    );
  },
);
